export const GTAG_COOKIE_GROUPS = {
  ad_user_data: 'ad_user_data',
  ad_personalization: 'ad_personalization',
  ad_storage: 'ad_storage',
  analytics_storage: 'analytics_storage',
};
